<template>
    <div
        v-if="slides.length"
        id="cz2__banner-ad--wrapper"
        class="cz2__banner-ad--wrapper"
    >
        <custom-swiper
            :autoHeight="true"
            :autoPlay="true"
            :showMask="false"
            :spaceBetween="0"
            :allowSticky="true"
        >
            <template v-slot:slides>
                <picture
                    v-for="slide in slides"
                    :key="slide.desktopImg"
                    class="swiper-slide"
                >
                    <source
                        media="(min-width:768px)"
                        :srcset="slide.desktopImg"
                    />
                    <img
                        :src="slide.mobileImg"
                        alt=""
                    />
                </picture>
            </template>
        </custom-swiper>
    </div>
</template>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2 {
        .cz2__banner-ad--wrapper {
            width: 100%;
            max-width: 968px;
            margin: 30px auto;

            @media (max-width: 1024px) {
                padding: 0 32px;
            }

            .swiper-container-outer {
                margin: 0;
                padding: 0;
                width: 100%;
            }

            .swiper-container {
                padding: 0;
            }

            .swiper-slide {
                aspect-ratio: 676/570;
                overflow: hidden;

                img {
                    height: 100%;
                    width: 100%;
                }
            }

            .swiper-custom-bullets__bullet {
                width: 32px;

                &::after {
                    width: 9px;
                    height: 9px;
                    opacity: 0.24;
                }

                &.swiper-custom-bullets__bullet--active {
                    &::before {
                        border-width: 1px;
                        top: 5px;
                        left: 5px;
                        width: 15px;
                        height: 15px;
                    }
                    &::after {
                        opacity: 1;
                    }
                }
            }

            @include respond-below(md) {
                .swiper-custom-arrow {
                    top: calc(100% + 4px);
                }
            }

            @include respond-above(md) {
                width: calc(100% - 100px);

                .swiper-custom-arrow,
                .swiper-custom-arrow.has-mobile-bullets {
                    &.swiper-custom-arrow--left {
                        right: calc(100% + 8px);
                    }

                    &.swiper-custom-arrow--right {
                        left: calc(100% + 8px);
                    }
                }

                .swiper-slide {
                    aspect-ratio: 24/5;
                }
            }

            @include respond-above(xl) {
                width: 100%;

                .swiper-custom-arrow,
                .swiper-custom-arrow.has-mobile-bullets {
                    &.swiper-custom-arrow--left {
                        right: calc(100% + 50px);
                    }

                    &.swiper-custom-arrow--right {
                        left: calc(100% + 50px);
                    }
                }
            }
        }
    }
</style>

<script>
    import CustomSwiper from './ui/CustomSwiper.vue';

    export default {
        components: {
            CustomSwiper,
        },

        data() {
            return {
                slides: [],
            };
        },

        computed: {
            globalSettings() {
                return this.$store.state.customizer.globalSettings?.blueprint?.custom;
            },
        },

        mounted() {
            if (this.globalSettings) {
                this.getSlides();
            }
        },

        methods: {
            getSlides() {
                for (let i = 1; i <= 5; i += 1) {
                    const desktopImage = this.globalSettings[`banner-ad-${i}`];
                    const mobileImage = this.globalSettings[`banner-ad-${i}-mobile`];

                    if (desktopImage && mobileImage) {
                        this.slides.push({
                            desktopImg: desktopImage,
                            mobileImg: mobileImage,
                        });
                    }
                }
            },
        },
    };
</script>
